import { render, staticRenderFns } from "./CoursewareDocumentBlock.vue?vue&type=template&id=8214ad98&scoped=true&"
import script from "./CoursewareDocumentBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareDocumentBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareDocumentBlock.vue?vue&type=style&index=0&id=8214ad98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8214ad98",
  null
  
)

export default component.exports